import { Alert, Badge, Group, Text, Tooltip } from "@mantine/core";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import type { LiveNutzer } from "../../hooks/useWeeklyLive.js";
import { useLive } from "./LiveKontext.js";

/** Wer außer mir gerade im Weekly ist — jede Person einmal, auch mit zwei Tabs. */
function andere(states: Map<number, Record<string, unknown>>, eigeneClientId: number): LiveNutzer[] {
  const personen = new Map<string, LiveNutzer>();
  for (const [id, s] of states) {
    const u = s["user"] as LiveNutzer | undefined;
    if (id !== eigeneClientId && u) personen.set(u.employeeId, u);
  }
  return [...personen.values()];
}

/** „Live" im Kopf des Weeklies, mit den Anwesenden; offline der Hinweis, dass nachgereicht wird. */
export function LiveStatus({ eigeneEmployeeId }: { eigeneEmployeeId: string | null }) {
  const { t } = useTranslation();
  const live = useLive();
  const [leute, setLeute] = useState<LiveNutzer[]>([]);

  useEffect(() => {
    if (!live) return;
    const neu = () =>
      setLeute(andere(live.anwesenheit.getStates() as Map<number, Record<string, unknown>>, live.doc.clientID).filter(
        (u) => u.employeeId !== eigeneEmployeeId,
      ));
    neu();
    live.anwesenheit.on("change", neu);
    return () => live.anwesenheit.off("change", neu);
  }, [live, eigeneEmployeeId]);

  if (!live || live.modus !== "live") return null;
  return (
    <>
      <Group gap={6}>
        <Tooltip label={t("weekly.live.hint")}>
          <Badge color={live.verbunden ? "green" : "yellow"} variant="light">
            {live.verbunden ? t("weekly.live.badge") : t("weekly.live.offline")}
          </Badge>
        </Tooltip>
        {leute.length > 0 && (
          <Text size="sm" c="dimmed">
            {t("weekly.live.others", { names: leute.map((u) => u.name).join(", ") })}
          </Text>
        )}
      </Group>
      {live.neuGeladen && (
        <Alert color="yellow" variant="light">
          {t("weekly.live.reset")}
        </Alert>
      )}
    </>
  );
}
